import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import logo from "../../Assets/Images/logoApp.png";
import {ModalActions} from "../../Store/Modal/Slice";
import {FORGOT_PASSWORD_MODAL, RECOVER_PASSWORD_MODAL} from "../../Store/Modal/Types";
import {useDispatch, useSelector} from "react-redux";
import {CircularProgress} from "@material-ui/core";
import {RootState} from "../../Store/Reducers";
import {hrefToObject, loginValidation, setLoadingIdle, toast} from "../../Utils/Utils";
import {LOADING_RECOVER_PASSWORD} from "../../Store/Loading/Types";
import {RecoveryPasswordParams} from "../../Models/RecoveryPasswordParams";
import {useHistory} from "react-router-dom";
import {AuthActions} from "../../Store/Auth/Slice";
import poweredBy from "../../Assets/Images/powered_by.png";

function Copyright() {
  return (
    <Typography  variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://www.auraba.com/">
        A URABÁ S.A.S 2016
      </Link>
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    width: 300
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  buttonProgress: {
    color: 'primary',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -90,
  },
}));

const SignInComponent = () => {

  const classes = useStyles();

  const dispatch = useDispatch();
  const history = useHistory();
  const [loginForm, setLoginForm] = useState({login:'', password:''});

  const {LoadingReducer: {loadingAuth, loadingRecoverPassword}} = useSelector((state: RootState) => state);


  const onSubmit = (e:any) => {
    e.preventDefault();

    const res = loginValidation(loginForm);
    if(res) {
      return toast(res,'error');
    }

    dispatch(AuthActions.getLogin(loginForm));
  };

  const handleOnChange = (event:any,type:string) => {
    setLoginForm({...loginForm,[type]:event.target.value});
  };

  const openForgotPasswordModal = () => {
    dispatch(ModalActions.openModal({modal:FORGOT_PASSWORD_MODAL}));
  };

  const { code, user_id }: RecoveryPasswordParams = hrefToObject();

  useEffect(()=>{
    if(Boolean(code) && Boolean(user_id)) {
      dispatch(ModalActions.openModal({modal:RECOVER_PASSWORD_MODAL}));
    }
  },[code,user_id,dispatch]);

  useEffect(()=> {
    if(loadingRecoverPassword.status.isResolved()) {
      dispatch(setLoadingIdle(LOADING_RECOVER_PASSWORD));
      history.push("/");
    }
  },[dispatch,loadingRecoverPassword,history]);

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <div className={classes.avatar}>
          <img src={logo} width="100%" alt=""/>
        </div>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            value={loginForm.login}
            onChange={(e)=>handleOnChange(e,'login')}
            id="email"
            label="Correo electronico"
            name="email"
            autoComplete="email"
            autoFocus
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Contraseña"
            type="password"
            aria-invalid={"true"}
            onChange={(e)=>handleOnChange(e,'password')}
            id="password"
            autoComplete="current-password"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={loadingAuth.status.isLoading()}
            color="secondary"
            onClick={(e)=>onSubmit(e)}
            className={classes.submit+ " outline-none"}
          >
            {loadingAuth.status.isLoading() && <CircularProgress size={24} className={classes.buttonProgress}/>}
            Iniciar Sesión
          </Button>
          <Grid container>
            <Grid item xs>
              <Link className="clickable" onClick={openForgotPasswordModal} >
                Olvidé mi contraseña
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>

      <div className="text-center p-4">
          <a
            className="powered"
            href="https://sbxcloud.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <h6>Powered by</h6>
            <img
              src={poweredBy}
              alt="sbxcloud"
            />
          </a>

      </div>

      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
};

export default SignInComponent;
